export default "\n<div *ngIf=\"displayCaneva\">\n<ngx-gallery [options]=\"galleryOptions\" [images]=\"galleryImages\"></ngx-gallery>\n</div>\n"